import { render, staticRenderFns } from "./dataItem.vue?vue&type=template&id=5be40630&scoped=true&"
import script from "./dataItem.vue?vue&type=script&lang=js&"
export * from "./dataItem.vue?vue&type=script&lang=js&"
import style0 from "./dataItem.vue?vue&type=style&index=0&id=5be40630&lang=less&scoped=true&"
import style1 from "./dataItem.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be40630",
  null
  
)

export default component.exports